export const fiscalDocumentFileClassName = {
  pending: '',
  uploaded: '',
  confirmed: 'bg-[#BEEFC233]',
  rejected: 'bg-[#FCCDCA33]',
};
